type Props = {
  isHovered: boolean;
  isClicked: boolean;
};

const MenuIcon = (props: Props) => {
  const { isHovered, isClicked } = props;

  return isClicked ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" />
      {isHovered ? (
        <rect
          x="10.2109"
          y="35.1673"
          width="36"
          height="3"
          rx="1.5"
          transform="rotate(-45 10.2109 35.1673)"
          fill="black"
          style={{ transition: "ease-out 200ms" }}
        />
      ) : (
        <rect
          x="11.626"
          y="33.7531"
          width="32"
          height="3"
          rx="1.5"
          transform="rotate(-45 11.626 33.7531)"
          fill="black"
          style={{ transition: "ease-out 200ms" }}
        />
      )}
      {isHovered ? (
        <rect
          x="12.333"
          y="9.71141"
          width="36"
          height="3"
          rx="1.5"
          transform="rotate(45 12.333 9.71141)"
          fill="black"
          style={{ transition: "ease-out 200ms" }}
        />
      ) : (
        <rect
          x="13.7471"
          y="11.1256"
          width="32"
          height="3"
          rx="1.5"
          transform="rotate(45 13.7471 11.1256)"
          fill="black"
          style={{ transition: "ease-out 200ms" }}
        />
      )}
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" />
      <rect x="8" y="22" width="32" height="3" rx="1.5" fill="black" />
      <rect
        x={isHovered ? "16" : "21"}
        y="13"
        width="16"
        height="3"
        rx="1.5"
        fill="black"
        style={{ transition: "ease-out 200ms" }}
      />
      <rect
        x={isHovered ? "16" : "11"}
        y="31"
        width="16"
        height="3"
        rx="1.5"
        fill="black"
        style={{ transition: "ease-out 200ms" }}
      />
    </svg>
  );
};

export default MenuIcon;
